export const manInit = require("./man_init.png");
export const manRun = require("./man_run.png");
export const redManInit = require("./red_man_init.png");
export const redManRun = require("./red_man_run.png");

export const womanInit = require("./woman_init.png");
export const womanRun = require("./woman_run.png");
export const redWomanInit = require("./red_woman_init.png");
export const redWomanRun = require("./red_woman_run.png");
